import LanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/LanguagePack";
import RevisableLanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/RevisableLanguagePack";
import LayoutManager from "../../../../../lib/html5-software-library/src/ranj/layout/LayoutManager";
import AbstractMediator from "../../../core/ui/AbstractMediator";
import TextTypeWriterAnimation from "../../../core/ui/animation/typewriters/TextTypeWriterAnimation";
import ClickEaterFactory from "../../../core/ui/ClickEaterFactory";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";
import HubEvent from "../../hub/event/HubEvent";
import StoryVariables from "../../util/StoryVariables";
import BriefingEvent from "../event/BriefingEvent";

export default class BriefingScreenMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LayoutManager} layoutManager 
     * @param {ClickEaterFactory} clickEaterFactory 
     * @param {RevisableLanguagePack} languagePack 
     */
    constructor(target, dispatcher, layoutManager, clickEaterFactory, languagePack, variableManager) {
        super(target, dispatcher, layoutManager, clickEaterFactory);

        this._languagePack = languagePack;
        this._variableManager = variableManager;

        this._typeWriterAnimation = null;
        this._chapterNumber = 1;
        this._weekNumber = 1;
        this._speedTypeWriting = 20;
        this._typeWritingCompleted = false;
    }

    initialize() {
        super.initialize();
        this.preventClickThrough();
        this._initContent();
        this._animateContent();
    }

    _initContent() {
        this._weekNumber = this._variableManager.getVariable(StoryVariables.WEEK_NUMBER);
        this._chapterNumber = this._variableManager.getVariable(StoryVariables.CHAPTER);

        this._target.ChapterContent.text = "";
        this._target.ChapterNumber.alpha = 0;
        this._target.ChapterTitle.alpha = 0;
        this._target.CWeekNumber.alpha = 0;
        this._target.BulletPoint.alpha = 0;

        this._target.ChapterNumber.text = this._languagePack.getText(`chapters.general.briefing.prefixChapterTitle`) + " " + this._chapterNumber;
        this._target.CWeekNumber.text = this._languagePack.getText(`chapters.general.briefing.prefixWeekTitle`) + " " + this._weekNumber;
        this._target.ChapterTitle.text = this._languagePack.getText(`chapters.chapter${this._chapterNumber}.briefing.title`);
        this._continueButton = this.createButton(this._target.ContinueButton, this._handleContinueButton.bind(this), this._languagePack.getText('chapters.general.briefing.continueButtonLabel'));
        this._continueButton.setEnabled(false);
        this._continueButton.skin.alpha = 0;
    }

    _animateContent() {
        const initDelay = 500;

        // Slide Down Animation
        const slideDownElement = this._target.BriefingTimelineBar;
        const slideDownDelay = 1000;
        const slideDownInitY = slideDownElement.y;
        slideDownElement.y -= (slideDownElement.nominalBounds.height / 2 + 50);
        slideDownElement.scaleY = 0;

        // Slide Right Animation
        const slideRightElement = this._target.ChapterContentContainer;
        const fadeSlideRightDelay = 750;
        const slideRightNegativeDelay = 400;
        const slideRightOffsetX = -50;
        const slideRightInitX = slideRightElement.x;
        slideRightElement.x += slideRightOffsetX;
        slideRightElement.alpha = 0;

        createjs.Tween.get(slideDownElement).wait(initDelay).to({ scaleY: 1, y: slideDownInitY}, slideDownDelay, createjs.Ease.sineOut);
        createjs.Tween.get(slideRightElement).wait(initDelay).wait(slideDownDelay - slideRightNegativeDelay).to({ alpha: 1, x: slideRightInitX }, fadeSlideRightDelay, createjs.Ease.sineInOut).call(() => {this._displayTextContent()});
    }
    _displayTextContent() {
        const fadeInDelay = 750;
        const els = [this._target.ChapterNumber, this._target.BulletPoint, this._target.CWeekNumber, this._target.ChapterTitle];
        for (let el of els) {
            createjs.Tween.get(el).to({ alpha: 1}, fadeInDelay, createjs.Ease.sineOut);
        }
        this._continueButton.setEnabled(true);
        createjs.Tween.get(this._continueButton.skin).to({ alpha: 1}, fadeInDelay, createjs.Ease.sineOut);
        this._typeWriterAnimation = TextTypeWriterAnimation.animate(this._target.ChapterContent, this._languagePack.getText(`chapters.chapter${this._chapterNumber}.briefing.body`), this._speedTypeWriting, 0, () => {
            this._typeWritingCompleted = true;
        });
    }

    destroy() {
        super.destroy();
    }

    _handleContinueButton() {
        if (this._typeWriterAnimation && !this._typeWritingCompleted) {
            this._typeWriterAnimation.forceFinish();
        } else {
            this.disableInteraction();
            this.dispatch(BriefingEvent.CLOSE_REQUEST);
        }
    }
}